import { DEMO_CALCULATOR_STEP } from 'config/constants'
import { Dispatch, SetStateAction, useEffect } from 'react'

import { isDemoPage } from '../../../../../utils/hooks'
import { useDemoStepPlaybackComplete } from '../../playback-hooks'

type UseDemoCustomsActionParams = {
  disabled?: boolean
  isAllowed?: boolean
}

export const useDemoCustomsAction = ({
  disabled = false,
  isAllowed = false,
}: UseDemoCustomsActionParams = {}) => {
  const isDemoMode = isDemoPage()

  return {
    buttonProps: {
      'data-demo-allowed': isDemoMode && isAllowed ? 'save-customs' : undefined,
      'data-demo-playback-action': isDemoMode ? 'save-customs' : undefined,
    },
    disabled: isDemoMode ? false : disabled,
    isDemoMode,
  }
}

export const useDemoCustomsCollapse = (
  setCollapsed: Dispatch<SetStateAction<boolean | undefined>>,
) => {
  const isDemoMode = isDemoPage()
  const isPlaybackComplete = useDemoStepPlaybackComplete(DEMO_CALCULATOR_STEP.CUSTOMS)

  useEffect(() => {
    if (isDemoMode && isPlaybackComplete) {
      setCollapsed(true)
    }
  }, [ isDemoMode, isPlaybackComplete, setCollapsed ])
}
